import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getDispositivo, postDispositivo } from "../../../redux/actions";
import styles from "./Dispositivo.module.css";

const Dispositivos = () => {
    const [valor, setValor] = useState("");
    const [error, setError] = useState("");

    const dispatch = useDispatch();
    const dispositivos = useSelector((state) => state.dispositivo);
   // console.log("DISPO:", dispositivos)

    useEffect(() => {
        dispatch(getDispositivo());
    }, [dispatch]);

    const handleCrearDispositivo = async () => {
        if (valor.trim() === "") {
            setError("Debe ingresar un valor para el dispositivo.");
            return;
        }

        const valorNumerico = parseFloat(valor);

        if (isNaN(valorNumerico) || valorNumerico <= 0) {
            setError("El valor debe ser un número positivo mayor a 0.");
            return;
        }

        try {
            await dispatch(postDispositivo({ dispositivo: valorNumerico }));
            setValor("");
            setError("");
            dispatch(getDispositivo());

            Swal.fire({
                icon: "success",
                title: "Dispositivo creado",
                text: "El dispositivo fue creado con éxito",
                confirmButtonColor: "#3559d1"
            });

        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: err.response?.data?.error || "Ocurrió un error al crear el dispositivo"
            });
        }
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.titulo}>Dispositivo de muestra</h2>

            <input
                type="number"
                placeholder="Escriba el valor del dispositivo"
                value={valor}
                onChange={(e) => setValor(e.target.value)}
                className={styles.input}
                min="0.01"
                step="0.01"
            />

            {error && <p className={styles.error}>{error}</p>}

            <button onClick={handleCrearDispositivo} className={styles.boton}>
                Crear Dispositivo
            </button>

            <label className={styles.label}>Dispositivos registrados:</label>
            <select className={styles.select}>
                {dispositivos?.length > 0 ? (
                    dispositivos.map((d) => (
                        <option key={d.id} value={d.dispositivo}>
                            {`${d.dispositivo} mm`}
                        </option>
                    ))
                ) : (
                    <option disabled>No hay dispositivos registrados</option>
                )}
            </select>
        </div>
    );
};

export default Dispositivos;
